/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AptosNetflowEcosystemFlowChainInfo } from '../models/AptosNetflowEcosystemFlowChainInfo';
import type { AptosNetflowEcosystemFlowTokenInfo } from '../models/AptosNetflowEcosystemFlowTokenInfo';
import type { AptosNetflowTopRankInfo } from '../models/AptosNetflowTopRankInfo';
import type { AptosNetflowTopRankTotalInfo } from '../models/AptosNetflowTopRankTotalInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AptosNetflowControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns AptosNetflowTopRankInfo OK
     * @throws ApiError
     */
    public getAptosNetflowTopRankOutflow({
        period = 'D30',
    }: {
        period?: 'H24' | 'D7' | 'D30' | 'D90' | 'Y1' | 'YTD',
    }): CancelablePromise<AptosNetflowTopRankInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/netflow/top-rank/outflow',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns AptosNetflowTopRankTotalInfo OK
     * @throws ApiError
     */
    public getAptosNetflowTopRankNetflow({
        period = 'D30',
        limit = 15,
    }: {
        period?: 'H24' | 'D7' | 'D30' | 'D90' | 'Y1' | 'YTD',
        limit?: number,
    }): CancelablePromise<AptosNetflowTopRankTotalInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/netflow/top-rank/netflow',
            query: {
                'period': period,
                'limit': limit,
            },
        });
    }

    /**
     * @returns AptosNetflowTopRankInfo OK
     * @throws ApiError
     */
    public getAptosNetflowTopRankInflow({
        period = 'D30',
    }: {
        period?: 'H24' | 'D7' | 'D30' | 'D90' | 'Y1' | 'YTD',
    }): CancelablePromise<AptosNetflowTopRankInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/netflow/top-rank/inflow',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns AptosNetflowEcosystemFlowTokenInfo OK
     * @throws ApiError
     */
    public getAptosNetflowTokenList({
        period = 'D30',
        page = 1,
        size = 25,
        sort = 'TOTAL',
        sortDirection = 'DESC',
    }: {
        period?: 'H24' | 'D7' | 'D30' | 'D90' | 'Y1' | 'YTD',
        page?: number,
        size?: number,
        sort?: 'IN' | 'OUT' | 'TOTAL',
        sortDirection?: 'ASC' | 'DESC',
    }): CancelablePromise<AptosNetflowEcosystemFlowTokenInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/netflow/ecosystem/token',
            query: {
                'period': period,
                'page': page,
                'size': size,
                'sort': sort,
                'sortDirection': sortDirection,
            },
        });
    }

    /**
     * @returns AptosNetflowEcosystemFlowChainInfo OK
     * @throws ApiError
     */
    public getAptosNetflowChainList({
        period = 'D30',
    }: {
        period?: 'H24' | 'D7' | 'D30' | 'D90' | 'Y1' | 'YTD',
    }): CancelablePromise<AptosNetflowEcosystemFlowChainInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/netflow/ecosystem/chain',
            query: {
                'period': period,
            },
        });
    }

}
